import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './PostAdStep1.css';

const mockCryptocurrencies = [
  {
    id: 'usdt',
    name: 'Tether US',
    symbol: 'USDT',
    balance: 41.21624269,
    icon: '₮'
  },
  {
    id: 'btc',
    name: 'Bitcoin',
    symbol: 'BTC',
    balance: 0.1842,
    icon: '₿'
  },
  {
    id: 'eth',
    name: 'Ethereum',
    symbol: 'ETH',
    balance: 2.5,
    icon: 'Ξ'
  }
];

const mockSavedPaymentMethods = [
  {
    id: '1',
    name: 'ZenithBank',
    accountName: 'Dayo Odewade',
    accountNumber: '4234626128',
    selected: false
  },
  {
    id: '2',
    name: 'MoniePoint',
    accountName: 'Dayo Odewade',
    accountNumber: '8034765716',
    selected: false
  },
  {
    id: '3',
    name: 'OPay',
    accountName: 'Dayo Odewade',
    accountNumber: '8034765716',
    selected: false
  }
];

const mockPaymentBanks = [
  { id: 'access', name: 'Access Bank', logo: null },
  { id: 'palmpay', name: 'Palmpay', logo: null },
  { id: 'fbn', name: 'FBN', fullName: 'FirstBank of Nigeria', logo: null },
  { id: 'uba', name: 'UBA', fullName: 'United Bank for Africa', logo: null },
  { id: 'fcmb', name: 'FCMB', fullName: 'First City Monument Bank', logo: null },
  { id: 'opay', name: 'OPay', logo: null }
];

const mockTimeLimits = [
  { id: '15', label: '15 Minutes' },
  { id: '30', label: '30 Minutes' },
  { id: '45', label: '45 Minutes' },
  { id: '60', label: '60 Minutes' }
];

const PostAdStep1: React.FC = () => {
  const navigate = useNavigate();
  
  const [tradeType, setTradeType] = useState<'buy' | 'sell'>('buy');
  const [selectedCrypto, setSelectedCrypto] = useState(mockCryptocurrencies[0]);
  const [selectedPaymentMethods, setSelectedPaymentMethods] = useState<typeof mockSavedPaymentMethods>([]);
  const [paymentTimeLimit, setPaymentTimeLimit] = useState(mockTimeLimits[0]);
  
  const [paymentMethodsModal, setPaymentMethodsModal] = useState(false);
  const [addPaymentMethodModal, setAddPaymentMethodModal] = useState(false);
  const [selectPaymentTypeModal, setSelectPaymentTypeModal] = useState(false);
  const [addPaymentDetailsModal, setAddPaymentDetailsModal] = useState(false);
  const [timeLimitModal, setTimeLimitModal] = useState(false);
  
  const [tempPaymentMethods, setTempPaymentMethods] = useState<typeof mockSavedPaymentMethods>([]);
  const [selectedBank, setSelectedBank] = useState<typeof mockPaymentBanks[0] | null>(null);
  const [accountName, setAccountName] = useState('');
  const [accountDetails, setAccountDetails] = useState('');

  const handlePaymentMethodSelect = (method: typeof mockSavedPaymentMethods[0]) => {
    const isSelected = tempPaymentMethods.some(pm => pm.id === method.id);
    
    if (isSelected) {
      setTempPaymentMethods(tempPaymentMethods.filter(pm => pm.id !== method.id));
    } else {
      if (tempPaymentMethods.length < 3) {
        setTempPaymentMethods([...tempPaymentMethods, { ...method, selected: true }]);
      }
    }
  };

  const handleConfirmPaymentMethods = () => {
    setSelectedPaymentMethods(tempPaymentMethods);
    setPaymentMethodsModal(false);
  };

  const handleRemovePaymentMethod = (methodId: string) => {
    setSelectedPaymentMethods(selectedPaymentMethods.filter(pm => pm.id !== methodId));
  };

  const handleOpenAddPaymentMethod = () => {
    setPaymentMethodsModal(false);
    setAddPaymentMethodModal(true);
  };

  const handleSelectBank = (bank: typeof mockPaymentBanks[0]) => {
    setSelectedBank(bank);
    setAddPaymentMethodModal(false);
    setSelectPaymentTypeModal(true);
  };

  const handleAddPaymentDetails = () => {
    setSelectPaymentTypeModal(false);
    setAddPaymentDetailsModal(true);
    setAccountName('Dayo Odewade');
  };

  const handleCompleteAddPayment = () => {
    setAddPaymentDetailsModal(false);
    setSelectedBank(null);
    setAccountName('');
    setAccountDetails('');
  };

  const handleNext = () => {
    if (selectedPaymentMethods.length === 0) {
      alert('Please select at least one payment method');
      return;
    }
    
    navigate('/post-ad-step-2');
  };

  return (
    <div className="post-ad-container">
      <header className="post-ad-header">
        <div className="post-ad-header-container">
          <button className="post-ad-back-button" onClick={() => navigate(-1)} aria-label="Go back">
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
              <path d="M10 12L6 8L10 4" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          </button>
          <h1 className="post-ad-title">Post an Ad</h1>
        </div>
        <div className="post-ad-progress">
          <div className="post-ad-progress-bar" style={{ width: '33.33%' }}></div>
        </div>
      </header>

      <div className="post-ad-content">
        <div className="post-ad-section">
          <label className="post-ad-label">Trade Type</label>
          <p className="post-ad-hint">Select buy or sell</p>
          
          <div className="post-ad-trade-type-buttons">
            <button
              className={`post-ad-trade-type-button ${tradeType === 'buy' ? 'active' : ''}`}
              onClick={() => setTradeType('buy')}
            >
              Buy
            </button>
            <button
              className={`post-ad-trade-type-button ${tradeType === 'sell' ? 'active' : ''}`}
              onClick={() => setTradeType('sell')}
            >
              Sell
            </button>
          </div>
        </div>

        <div className="post-ad-card">
          <h3 className="post-ad-card-title">Asset & Method</h3>
          <p className="post-ad-card-subtitle">Select cryptocurrency and payment options</p>

          <label className="post-ad-label">Cryptocurrency</label>
          <button className="post-ad-select-button">
            <div className="post-ad-crypto-icon">{selectedCrypto.icon}</div>
            <div className="post-ad-select-info">
              <div className="post-ad-select-name">{selectedCrypto.name}</div>
              <div className="post-ad-select-symbol">{selectedCrypto.symbol}</div>
            </div>
            <svg className="post-ad-select-arrow" width="16" height="16" viewBox="0 0 16 16" fill="none">
              <path d="M4 6L8 10L12 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          </button>

          <div className="post-ad-balance">
            <span className="post-ad-balance-dot">●</span>
            Balance: {selectedCrypto.balance} {selectedCrypto.symbol}
          </div>

          <label className="post-ad-label">Payment Method</label>
          
          <div className="post-ad-payment-methods">
            {selectedPaymentMethods.map((method) => (
              <button key={method.id} className="post-ad-payment-chip">
                {method.name}
                <svg 
                  width="16" 
                  height="16" 
                  viewBox="0 0 16 16" 
                  fill="none"
                  onClick={(e) => {
                    e.stopPropagation();
                    handleRemovePaymentMethod(method.id);
                  }}
                >
                  <path d="M12 4L4 12M4 4L12 12" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </button>
            ))}
            
            <button 
              className="post-ad-add-button"
              onClick={() => {
                setTempPaymentMethods(selectedPaymentMethods);
                setPaymentMethodsModal(true);
              }}
            >
              <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                <path d="M8 3V13M3 8H13" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
              Add
            </button>
          </div>

          <p className="post-ad-hint">Select up to 3 payment methods</p>

          <label className="post-ad-label">Payment Time Limit</label>
          <button className="post-ad-time-limit-button" onClick={() => setTimeLimitModal(true)}>
            {paymentTimeLimit.label}
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
              <path d="M4 6L8 10L12 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          </button>
        </div>

        <button className="post-ad-next-button" onClick={handleNext}>
          Next
        </button>
      </div>

      {paymentMethodsModal && (
        <div className="post-ad-modal-overlay" onClick={() => setPaymentMethodsModal(false)}>
          <div className="post-ad-modal-dialog" onClick={(e) => e.stopPropagation()}>
            <button
              className="post-ad-modal-close"
              onClick={() => setPaymentMethodsModal(false)}
              aria-label="Close modal"
            >
              <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                <path d="M12 4L4 12M4 4L12 12" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </button>

            <h2 className="post-ad-modal-title">Payment Methods</h2>
            <p className="post-ad-modal-subtitle">Select up to 3 payment methods</p>

            <div className="post-ad-modal-content">
              {mockSavedPaymentMethods.map((method) => {
                const isSelected = tempPaymentMethods.some(pm => pm.id === method.id);
                return (
                  <button
                    key={method.id}
                    className="post-ad-payment-method-item"
                    onClick={() => handlePaymentMethodSelect(method)}
                  >
                    <div className="post-ad-payment-method-info">
                      <div className="post-ad-payment-method-name">{method.name}</div>
                      <div className="post-ad-payment-method-details">
                        {method.accountName} | {method.accountNumber}
                      </div>
                    </div>
                    <div className={`post-ad-checkbox ${isSelected ? 'checked' : ''}`}>
                      {isSelected && (
                        <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                          <path d="M13 4L6 11L3 8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                        </svg>
                      )}
                    </div>
                  </button>
                );
              })}

              <button className="post-ad-add-new-button" onClick={handleOpenAddPaymentMethod}>
                + Add New Payment Method
              </button>
            </div>

            <button className="post-ad-modal-confirm-button" onClick={handleConfirmPaymentMethods}>
              Confirm Selection
            </button>
          </div>
        </div>
      )}

      {addPaymentMethodModal && (
        <div className="post-ad-modal-overlay" onClick={() => setAddPaymentMethodModal(false)}>
          <div className="post-ad-modal-dialog post-ad-modal-large" onClick={(e) => e.stopPropagation()}>
            <button
              className="post-ad-modal-close"
              onClick={() => setAddPaymentMethodModal(false)}
              aria-label="Close modal"
            >
              <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                <path d="M12 4L4 12M4 4L12 12" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </button>

            <h2 className="post-ad-modal-title">Add Payment Method</h2>

            <div className="post-ad-modal-content post-ad-bank-list">
              {mockPaymentBanks.map((bank) => (
                <button
                  key={bank.id}
                  className="post-ad-bank-item"
                  onClick={() => handleSelectBank(bank)}
                >
                  <div className="post-ad-bank-icon">
                    {bank.name.charAt(0)}
                  </div>
                  <div className="post-ad-bank-info">
                    <div className="post-ad-bank-name">{bank.name}</div>
                    <div className="post-ad-bank-fullname">{bank.fullName || bank.name}</div>
                  </div>
                  <svg className="post-ad-bank-arrow" width="20" height="20" viewBox="0 0 20 20" fill="none">
                    <path d="M7.5 15L12.5 10L7.5 5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                </button>
              ))}
            </div>
          </div>
        </div>
      )}

      {selectPaymentTypeModal && selectedBank && (
        <div className="post-ad-modal-overlay" onClick={() => setSelectPaymentTypeModal(false)}>
          <div className="post-ad-modal-dialog" onClick={(e) => e.stopPropagation()}>
            <button
              className="post-ad-modal-close"
              onClick={() => setSelectPaymentTypeModal(false)}
              aria-label="Close modal"
            >
              <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                <path d="M12 4L4 12M4 4L12 12" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </button>

            <div className="post-ad-modal-header-with-back">
              <button
                className="post-ad-modal-back-button"
                onClick={() => {
                  setSelectPaymentTypeModal(false);
                  setAddPaymentMethodModal(true);
                }}
                aria-label="Go back"
              >
                <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                  <path d="M12.5 15L7.5 10L12.5 5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </button>
              <h2 className="post-ad-modal-title">Add Payment Method</h2>
            </div>

            <div className="post-ad-modal-content">
              <div className="post-ad-info-banner">
                <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                  <circle cx="10" cy="10" r="8" stroke="currentColor" strokeWidth="2"/>
                  <path d="M10 6V10M10 14H10.01" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
                </svg>
                <p>
                  The buyer will be presented with this payment method for accepting fiat transfers during the transaction. 
                  Please verify that the provided information is accurate, valid, and corresponds to your KYC details on Coinsher.
                </p>
              </div>

              <div className="post-ad-selected-bank">
                <div className="post-ad-bank-icon-large">
                  {selectedBank.name.charAt(0)}
                </div>
                <div className="post-ad-selected-bank-info">
                  <div className="post-ad-selected-bank-name">{selectedBank.name}</div>
                  <div className="post-ad-selected-bank-fullname">{selectedBank.fullName || selectedBank.name}</div>
                </div>
              </div>

              <div className="post-ad-form-group">
                <label className="post-ad-form-label">Account Name</label>
                <input
                  type="text"
                  className="post-ad-form-input"
                  placeholder="Dayo Odewade"
                  value={accountName}
                  onChange={(e) => setAccountName(e.target.value)}
                />
              </div>

              <div className="post-ad-form-group">
                <label className="post-ad-form-label">Account Details</label>
                <input
                  type="text"
                  className="post-ad-form-input"
                  placeholder="Account number / Email"
                  value={accountDetails}
                  onChange={(e) => setAccountDetails(e.target.value)}
                />
              </div>

              <button className="post-ad-modal-confirm-button" onClick={handleAddPaymentDetails}>
                Add
              </button>
            </div>
          </div>
        </div>
      )}

      {addPaymentDetailsModal && (
        <div className="post-ad-modal-overlay" onClick={handleCompleteAddPayment}>
          <div className="post-ad-modal-dialog post-ad-modal-small" onClick={(e) => e.stopPropagation()}>
            <button
              className="post-ad-modal-close"
              onClick={handleCompleteAddPayment}
              aria-label="Close modal"
            >
              <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                <path d="M12 4L4 12M4 4L12 12" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </button>

            <div className="post-ad-success-content">
              <div className="post-ad-success-icon">
                <svg width="36" height="36" viewBox="0 0 36 36" fill="none">
                  <path d="M30 9L13.5 25.5L6 18" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </div>
              <h3 className="post-ad-success-title">Success!</h3>
              <p className="post-ad-success-message">Payment method added successfully</p>
              <button className="post-ad-success-button" onClick={handleCompleteAddPayment}>
                Done
              </button>
            </div>
          </div>
        </div>
      )}

      {timeLimitModal && (
        <div className="post-ad-modal-overlay" onClick={() => setTimeLimitModal(false)}>
          <div className="post-ad-modal-dialog" onClick={(e) => e.stopPropagation()}>
            <button
              className="post-ad-modal-close"
              onClick={() => setTimeLimitModal(false)}
              aria-label="Close modal"
            >
              <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                <path d="M12 4L4 12M4 4L12 12" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </button>

            <h2 className="post-ad-modal-title">Payment Time Limit</h2>
            <p className="post-ad-modal-subtitle">Choose how long buyers have to pay</p>

            <div className="post-ad-modal-content post-ad-time-limit-list">
              {mockTimeLimits.map((timeLimit) => (
                <button
                  key={timeLimit.id}
                  className="post-ad-time-limit-option"
                  onClick={() => {
                    setPaymentTimeLimit(timeLimit);
                    setTimeLimitModal(false);
                  }}
                >
                  {timeLimit.label}
                </button>
              ))}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default PostAdStep1;
